module.exports = __webpack_public_path__ + "static/img/yn.c82d8b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/yn.png
// module id = RZoo
// module chunks = 1